export const UNKNOWN_TEAM_NAME = 'Unknown team';

export enum TeamInstructionKindForMultipleValueResources {
  ADD_MEMBERS = 'addMembers',
  REMOVE_MEMBERS = 'removeMembers',
  ADD_CUSTOM_ROLES = 'addCustomRoles',
  REMOVE_CUSTOM_ROLES = 'removeCustomRoles',
}

export enum TeamInstructionActionSet {
  MAINTAIN_TEAM = 'maintainTeam',
}

export enum TeamInstructionKindForSingleValueResources {
  UPDATE_NAME = 'updateName',
  UPDATE_DESCRIPTION = 'updateDescription',
}

export enum TeamInstructionKindForPermissionGrants {
  ADD_PERMISSION_GRANTS = 'addPermissionGrants',
  REMOVE_PERMISSION_GRANTS = 'removePermissionGrants',
}
